export enum Experiment {
  EditorOOI = 'specs.loyalty.EditorOOIMyRewards',
}
